
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsfb1464478d9122454411f67368bcc4f4en from './en.yaml'
            i18n.addResourceBundle('en', 'fb1464478d9122454411f67368bcc4f4', flattenObject(nsfb1464478d9122454411f67368bcc4f4en), true, true);
        
        export default 'fb1464478d9122454411f67368bcc4f4';
    